import { ChangeDetectorRef, Component, ElementRef, Injectable, OnInit, ViewChild } from '@angular/core';
import { SocialService } from '../../../../../../common/services/Social.service';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { environment } from '../../../../../../../environments/environment';
import { ZaloConst } from '../zalo/zalo.const';
import { FacebookConst } from './facebook.const';
import { TableAction } from '../../../../../../components/table-component/table.const';
import { BaseListComponent } from '../../../../../../components/base-list.component';
import { BsModalService } from 'ngx-bootstrap';

declare var $: any;
declare var FB: any;
const FACEBOOK_URL = environment.url_ottgateway;
const APP_ID = environment.app_facebook_id;
const CONFIGURATION_ID = environment.facebook_configuration_id;

@Component({
  selector: 'settings-conversation-facebook',
  templateUrl: './facebook.component.html',
  styleUrls: ['./facebook.component.css'],
  providers: [SocialService],
})
@Injectable()
export class FacebookComponent extends BaseListComponent {
  @ViewChild('templatePage') templatePage: ElementRef;

  public user: any;
  public list: any = [];
  public pages: any = [];
  public objPages: any = {};
  public access_token: any;
  public check_exist: any = {};
  public modalRef2: any;
  public no_image: any = 'assets/images/img_notfound.png';

  public lstChecked: any = [];
  public isCheckAll = false;
  totalItem: any = 0;
  totalPage: any = 0;
  public displayColumns: any = [];
  public currentPage = 1;
  public totalRow = 0;
  public page_size = 10;

  constructor(
    protected changeDetector: ChangeDetectorRef,
    protected modalService: BsModalService,
    protected toastr: ToastrService,
    private socialService: SocialService
  ) {
    super(changeDetector, toastr, modalService);
    this.displayColumns = FacebookConst.displayColumns();
    this.initFacebookSdk();
  }

  ngOnInit() {
    this.loadData();
  }

  async loadData(request: any = {}, sort: any = {}) {
    this.data = [];
    request.type = 1;
    const payload = await this.buildBasePayload(request, sort);
    this.socialService.listPageV2(payload).subscribe(res => {
      if (res.status == 200 && res.error == false) {
        this.data = res.data.list;
        this.initPage(res.data.total);
        this.data = this.data.map(e => {
          e.is_valid = FacebookConst.displayValidColumns(e.is_valid);
          return e;
        });
      } else {
        this.data = [];
      }
    });
  }

  checkUse(page_id) {
    this.check_exist[page_id] = !this.check_exist[page_id];
  }

  deletePage(page_id) {
    const y = confirm('Bạn có muốn xóa trang này không?');
    if (y) {
      this.socialService.deletePageV2(page_id).subscribe(res => {
        if (!res.error && res.status == 200) {
          this.toastr.success('Xóa page thành công', '', {
            timeOut: 4000,
            positionClass: 'toast-bottom-right',
          });
          this.loadData();
        }
      });
    }
  }

  savePage() {
    const observableBatch = [];
    for (const e in this.check_exist) {
      if (this.check_exist[e]) {
        const payload = {
          access_token: this.objPages[e].access_token,
          page_id: this.objPages[e].id,
          page_name: this.objPages[e].name,
          category: this.objPages[e].category,
        };
        observableBatch.push(this.socialService.addPageV2(payload));
      }
    }

    Observable.forkJoin(observableBatch).subscribe(data => {
      this.toastr.success('Lưu page thành công', '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
      this.loadData();
      this.modalRef2.hide();
    });
  }

  login() {
    window.open(FACEBOOK_URL + '/facebooklogin.html?access_token=' + localStorage.getItem('Access-Token'), '_blank');
  }

  handleAction(type: any, item?: any) {
    switch (type) {
      case TableAction.add:
        this.loginWithFacebook();
        break;
      case TableAction.delete:
        this.deletePage(item.page_id);
        break;
    }
  }
  // Fb login
  initFacebookSdk() {
    (window as any).fbAsyncInit = async function () {
      FB.init({
        appId: APP_ID,
        autoLogAppEvents: true,
        xfbml: false,
        version: 'v19.0',
      });
    };

    (function (d, s, id) {
      let js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        return;
      }
      js = d.createElement(s);
      js.id = id;
      js.src = 'https://connect.facebook.net/en_US/sdk.js';
      fjs.parentNode.insertBefore(js, fjs);
    })(document, 'script', 'facebook-jssdk');
  }

  async loginWithFacebook() {
    FB.login(
      async (response: any) => {
        if (response.authResponse) {
          const { accessToken, userID } = response.authResponse;
          const state = this.user.tenant_id + '_' + this.user._id;
          console.log('Logged in:', response);
          this.socialService.loginFacebookSuccess(accessToken, state, userID).subscribe(res => {
            if (res) {
              this.toastr.success('Thêm mới page thành công', '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right',
              });
              setTimeout(() => {
                this.loadData();
              }, 1500);
            } else {
              this.toastr.error('Thêm mới page thất bại', '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right',
              });
            }
          });
        } else {
          console.error('User cancelled login or did not fully authorize.');
          this.toastr.error('User cancelled login or did not fully authorize. Fb', '', {
            timeOut: 4000,
            positionClass: 'toast-bottom-right',
          });
        }
      },
      {
        scope:
          'email,public_profile,pages_manage_engagement,pages_manage_metadata,pages_manage_posts,pages_read_engagement,pages_messaging,pages_read_user_content,pages_show_list',
      }
    );
    this.loadData();
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/setting/conversation/facebook/facebook.component.ts